import React, { useCallback } from 'react';

interface UseInputHandlingProps {
  onSave: () => void;
  isEditing?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: (value: string) => void;
}

export const useInputHandling = ({
  onSave,
  isEditing = true,
  value = '',
  onChange,
  onFocus,
  onBlur,
}: UseInputHandlingProps) => {
  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (isEditing && e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSave();
    }
  }, [isEditing, onSave]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  }, [onChange]);

  const handleBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    onBlur?.(e.target.value);
  }, [onBlur]);

  const handleFocus = useCallback(() => {
    onFocus?.();
  }, [onFocus]);

  return {
    inputProps: {
      value,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
    },
    handleKeyDown, // Also expose the handler for container divs
  };
}; 